import * as yup from "yup";

export const reportPurchaseValidation = yup
  .object()
  .shape({
    negaraAsal: yup
      .array()
      .of(yup.string())
      .when("laporanTersedia", {
        is: true,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .when("tipePembelian", {
        is: (value) => value === "Import",
        then: (schema) => schema.required("Harus diisi"),
        otherwise: (schema) => schema.notRequired(),
      }),
    dataImport: yup
      .array()
      .when("laporanTersedia", {
        is: true,
        then: (schema) =>
          schema
            .of(
              yup
                .object()
                .shape({
                  pelabuhanBongkarId: yup.string().required("Harus diisi"),
                  dataTransporters: yup.array().min(1, "Minimal 1 perusahaan transporter"),
                  tanggalImport: yup.string().required("Harus diisi"),
                  jumlahBahanB3DiBeli: yup.number().typeError("Harus angka").required("Harus diisi"),
                })
                .required()
            )
            .min(1, "Minimal 1 data impor"),
        otherwise: (schema) => schema.notRequired(),
      })
      .when("tipePembelian", {
        is: (value) => value === "Import",
        then: (schema) =>
          schema
            .of(
              yup.object().shape({
                pelabuhanBongkarId: yup.string().required("Harus diisi"),
                dataTransporters: yup.array().min(1, "Minimal 1 perusahaan transporter"),
                tanggalImport: yup.date().required("Harus diisi"),
                jumlahBahanB3DiBeli: yup.number().typeError("Harus angka").required("Harus diisi"),
              })
            )
            .min(1, "Minimal 1 data impor"),
        otherwise: (schema) => schema.notRequired(),
      }),
    dataSuppliers: yup
      .array()
      .when("laporanTersedia", {
        is: true,
        then: (schema) =>
          schema
            .of(
              yup
                .object()
                .shape({
                  supplierId: yup.string().required("Harus diisi"),
                  jumlahPembelianB3: yup.number().typeError("Harus angka").required("Harus diisi"),
                })
                .required()
            )
            .min(1, "Minimal 1 supplier"),
        otherwise: (schema) => schema.notRequired(),
      })
      .when("tipePembelian", {
        is: (value) => value === "Lokal",
        then: (schema) =>
          schema
            .of(
              yup.object().shape({
                supplierId: yup.string().required("Harus diisi"),
                jumlahPembelianB3: yup.number().typeError("Harus angka").required("Harus diisi"),
              })
            )
            .min(1, "Minimal 1 data impor"),
        otherwise: (schema) => schema.notRequired(),
      }),
  })
  .required();

export const reportAddMaterialPurchaseValidation = yup.object().shape({
  companyId: yup.string().required("Harus diisi"),
  dataBahanB3Id: yup.string().required("Harus diisi"),
  tipePembelian: yup.string().required("Harus diisi"),
  registrasiId: yup.string().when("tipePembelian", {
    is: (value) => value === "Import",
    then: (schema) => schema.required("Harus diisi"),
    otherwise: (schema) => schema.notRequired(),
  }),
  // Pembelian lokal dibeli DARI perusahaan lain: pemasok dan SK-nya wajib,
  // menggantikan isian bebas nomor SK.
  supplierCompanyId: yup.string().when("tipePembelian", {
    is: (value) => value === "Lokal",
    then: (schema) => schema.required("Harus diisi"),
    otherwise: (schema) => schema.notRequired(),
  }),
  supplierRegistrasiId: yup.string().when("tipePembelian", {
    is: (value) => value === "Lokal",
    then: (schema) => schema.required("Harus diisi"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
